import { useState, useEffect } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Infinity as InfinityIcon } from 'lucide-react';

function formatMinutesLabel(minutes) {
  if (minutes === 0) return null;
  return `${minutes} min`;
}

export default function ButtonGroupTiempo({
  value,
  onChange,
  modo,
  options = [0, 60, 120, 360],
  enarmValue = 360,
}) {
  const [alignment, setAlignment] = useState(value);

  const normalizedOptions = (Array.isArray(options) ? options : []).reduce((acc, item) => {
    const parsed = Number(item);
    if (!Number.isFinite(parsed) || parsed < 0 || acc.includes(parsed)) {
      return acc;
    }

    acc.push(parsed);
    return acc;
  }, []);

  const finalOptions =
    modo === 'enarm' && !normalizedOptions.includes(enarmValue)
      ? [...normalizedOptions, enarmValue]
      : normalizedOptions;

  useEffect(() => {
    setAlignment(value);
  }, [value]);

  useEffect(() => {
    if (modo === 'enarm') {
      setAlignment(enarmValue);
      if (value !== enarmValue) {
        onChange(enarmValue);
      }
    }
  }, [modo, enarmValue, onChange, value]);

  const handleChange = (event, newAlignment) => {
    if (newAlignment === null) return;
    setAlignment(newAlignment);
    onChange(newAlignment);
  };

  const buttonSx = {
    flex: 1,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    borderColor: 'transparent',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    px: { xs: 0.75, sm: 1.5 },
    py: { xs: 0.75, sm: 1 },
    fontSize: { xs: '0.68rem', sm: '0.875rem' },
    '&.Mui-selected': {
      backgroundColor: '#6366f1',
      color: 'secondary.contrastText',
      boxShadow: 'none',
      borderColor: 'transparent',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#4f46e5',
      color: 'secondary.contrastText',
      borderColor: 'transparent',
    },
  };

  return (
    <>
    <h3 className="text-sm font-semibold mb-2">Tiempo</h3>
    <ToggleButtonGroup
      color="secondary"
      value={alignment}
      exclusive
      onChange={handleChange}
      aria-label="Tiempo"
      sx={{
        width: '100%',
        border: '1px solid #cbd5e1',
        borderRadius: '10px',
        overflow: 'hidden',
        '& .MuiToggleButtonGroup-grouped': {
          margin: 0,
          border: 0,
          borderRadius: 0,
        },
        '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
          borderRight: '1px solid #e2e8f0',
        },
      }}
      disabled={modo === 'enarm'}
    >
      {finalOptions.map((option) => (
        <ToggleButton
          key={option}
          value={option}
          sx={buttonSx}
          disabled={modo === 'enarm'}
        >
          {option === 0 ? (
            <InfinityIcon size={20} style={{ marginRight: 8 }} />
          ) : (
            formatMinutesLabel(option)
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    </>
  );
}